var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.loading
    ? _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("show-on-display") },
                        model: {
                          value: _vm.group.ShowOnDisplay,
                          callback: function ($$v) {
                            _vm.$set(_vm.group, "ShowOnDisplay", $$v)
                          },
                          expression: "group.ShowOnDisplay",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [_c("w-col", { attrs: { xs: "12" } }, [_c("w-divider")], 1)],
                1
              ),
              !_vm.group.ImageAWSFile
                ? _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-file-upload", {
                            attrs: {
                              sending: _vm.isUploadingImage,
                              "allowed-extensions": _vm.allowedExtensions,
                              label: _vm.$ct("group-image"),
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onImageInput($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "w-row",
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "photo" },
                            [
                              _c("img", {
                                staticClass: "group",
                                attrs: {
                                  src: _vm.group.ImageAWSFile.getUrl(),
                                  alt: "Group photo",
                                },
                              }),
                              _c(
                                "w-button",
                                {
                                  staticClass: "close-button cancel sm",
                                  attrs: { "w-tooltip": "$ct('remove-image')" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeImage()
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "times" } })],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { disabled: _vm.controlsDisabled, icon: "cancel" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "confirm",
                  attrs: { disabled: _vm.controlsDisabled, icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }